// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header_3V9XB","heading":"SectionHeader_heading_1kwRR"};